import React, { useState, useEffect } from 'react';

import { SCREEN_NAME } from '../../types/common/CommonType';

import { SearchResultBody } from './SearchResultBody';
import { CoverProgressLoading } from '../../components/CoverProgressLoading';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { addRow as setMoveScreen } from '../../slice/ScreenHistorySlice';

export const SearchResult = () => {
    // API実行状況管理
    const [loadingStatus, setLoadingStatus] = useState(false);
    // 検索結果
    const searchResult = useAppSelector((s) => s.SearchResult);
    // 検索文言
    const searchWord = useAppSelector((s) => s.SearchWord);
    // 見積り問合せ
    const estimateInquiry = useAppSelector((s) => s.EstimateInquiry);

    const dispatch = useAppDispatch();

    useEffect(() => {
        setLoadingStatus(false);
        // 検索結果が存在すれば表示
        if (searchResult) {
            setLoadingStatus(true);
        }
    }, [searchResult]);

    // 画面遷移ルート追加
    useEffect(() => {
        dispatch(setMoveScreen(SCREEN_NAME.SEARCH_RESULT));
    }, []);

    return (
        <>
            {loadingStatus ? (
                <SearchResultBody
                    searchResult={searchResult}
                    searchWord={searchWord}
                    deviceList={estimateInquiry.deviceList}
                    dispatch={dispatch}
                />
            ) : (
                <CoverProgressLoading />
            )}
        </>
    );
};
